module.exports = __webpack_public_path__ + "static/media/pinpush.fb1c1a9f.svg";